import { forwardRef } from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from 'components/ui/button';
import { CHAT_MAIN_COLUMN_CLASS } from 'constant/chat-layout';

type ScrollToBottomControlProps = {
  isStreaming: boolean;
  bottomOffset: number;
  onClick: () => void;
};

function StreamingDots() {
  return (
    <span className="inline-flex items-center gap-[3px]" aria-hidden>
      {[0, 1, 2].map((delay) => (
        <span
          key={delay}
          className="h-1.5 w-1.5 rounded-full bg-[#8d8d8d] dark:bg-[#c4c4c4]"
          style={{
            animation: 'klax-scroll-dot 1.2s ease-in-out infinite',
            animationDelay: `${delay * 160}ms`,
          }}
        />
      ))}
      <style>{`
        @keyframes klax-scroll-dot {
          0%, 80%, 100% { opacity: .35; transform: translateY(0); }
          40% { opacity: 1; transform: translateY(-2px); }
        }
      `}</style>
    </span>
  );
}

export const ScrollToBottomControl = forwardRef<HTMLButtonElement, ScrollToBottomControlProps>(
  function ScrollToBottomControl({ isStreaming, bottomOffset, onClick }, ref) {
    return (
      <div
        className="pointer-events-none absolute inset-x-0 z-20 flex justify-center"
        style={{ bottom: `${bottomOffset}px` }}
      >
        <div className={`pointer-events-auto flex justify-center ${CHAT_MAIN_COLUMN_CLASS}`}>
          <Button
            ref={ref}
            variant="outline"
            aria-label={isStreaming ? 'Generating response' : 'Scroll to bottom'}
            className="h-10 w-10 rounded-full border"
            onClick={onClick}
          >
            {isStreaming ? <StreamingDots /> : <ArrowDown size={16} />}
          </Button>
        </div>
      </div>
    );
  }
);
